/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useCallback, useState } from 'react';
import { Button } from '../common';
import { LobbiesListHeader } from './LobbiesListHeader';
import { MenuContainer } from '../menu/MenuContainer';
import { LobbyCard } from './LobbyCard';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogTitleHighscores } from '../highscores/components/DialogTitleCustom';
import { OpenState } from './CreateLobby';
import { link_comp } from '../../game-engine/maps-utils/constants';

export type LobbyStatus = 'checking' | 'created' | 'ended' | 'started' | 'failed' | 'refunded';
export type LoadingState =
  | 'FailedJoin'
  | 'FailedStart'
  | 'SuccessfulJoin'
  | 'SuccessfulStart'
  | 'LoadingJoin'
  | 'LoadingStart'
  | 'CanceledJoin'
  | 'None';

export interface ILobbiesListProps {
  onClickBack: () => void;
  onClickRace: () => void;
  updateRaceLobbyProps: (arg: any) => void;
}

interface ILobbyDataProps extends Array<any> {}

type ILobbiesDataProps = {
  [key in LobbyStatus]: ILobbyDataProps | string[];
};

export const LobbiesList = (props: ILobbiesListProps) => {
  const { onClickBack, onClickRace, updateRaceLobbyProps } = props;

  const [lobbiesStatus, setLobbiesStatus] = React.useState<LobbyStatus>('started');
  const setStatus = (event: React.MouseEvent<HTMLElement>, status: LobbyStatus) => {
    if (status !== null) setLobbiesStatus(status);
  };

  let accountAddress = JSON.parse(localStorage.getItem('userData') as any | '');

  const getLobbies = (onFinish?: () => void) => {
    fetch(link_comp + '/lobbies/' + accountAddress)
      .then((res) => res.json())
      .then((data) => {
        getLobbiesData(data.lobbies);
        if (onFinish) onFinish();
      });
  };

  // const link_comp = `${host_link}:${host_port}`;
  const [lobbiesData, getLobbiesData] = React.useState<ILobbiesDataProps>();
  React.useEffect(() => {
    getLobbies();
  }, []);

  const [lobbiesArr, getLobbiesArr] = React.useState<ILobbyDataProps>([]);
  React.useEffect(() => {
    if (lobbiesData) {
      getLobbiesArr(lobbiesData[lobbiesStatus as LobbyStatus]);
    } else getLobbiesArr([]);
  }, [lobbiesData, lobbiesStatus]);

  const [loadingState, setLoadingState] = useState<LoadingState>('None');
  const [openState, setOpenState] = useState<OpenState>(true);

  const handleClose = () => {
    setOpenState(false);
    setLoadingState('None');
  };

  const content = (
    <>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        `}
      >
        <LobbiesListHeader lobbiesStatus={lobbiesStatus} setStatus={setStatus} handleRefetch={getLobbies} />

        <div
          css={css`
            width: 100%;
          `}
        >
          <div
            css={css`
              width: 80%;
              justify-content: space-between;
              display: flex;
              flex-wrap: wrap;
              padding: 0 10%;
              box-sizing: initial;
              text-align: left;
              margin: 20px 0;
            `}
          >
            {lobbiesData ? (
              lobbiesArr.map((value, index: number) => (
                <LobbyCard
                  data={value}
                  key={index}
                  accountAddress={accountAddress}
                  setLoadingState={setLoadingState}
                  setOpenState={setOpenState}
                  updateRaceLobbyProps={updateRaceLobbyProps}
                  onClickRace={onClickRace}
                  handleRefetch={getLobbies}
                  setLobbiesStatus={setLobbiesStatus}
                />
              ))
            ) : (
              <span className={'display-6 fw-bold'}>loading...</span>
            )}
          </div>
        </div>
      </div>
      <Dialog open={loadingState !== 'None' && openState === true} onClose={handleClose} disableEnforceFocus>
        <DialogTitleHighscores id={'state'} onClose={handleClose}>
          {loadingState === 'SuccessfulJoin'
            ? 'Congratulations'
            : loadingState === 'LoadingJoin'
            ? 'Loading...'
            : loadingState === 'CanceledJoin'
            ? 'Canceled'
            : loadingState === 'SuccessfulStart'
            ? 'Congratulations'
            : loadingState === 'LoadingStart'
            ? 'Loading...'
            : ''}
        </DialogTitleHighscores>
        <DialogContent className="main-color">
          {loadingState === 'SuccessfulJoin'
            ? 'Succesfully joined the lobby'
            : loadingState === 'LoadingJoin'
            ? 'Joining the lobby, please hang tight!'
            : loadingState === 'CanceledJoin'
            ? 'The join lobby has been canceled'
            : loadingState === 'SuccessfulStart'
            ? 'Succesfully started the lobby'
            : loadingState === 'LoadingStart'
            ? 'Starting the lobby, please hang tight!'
            : ''}
        </DialogContent>
        <DialogActions className="main-color">
          <Button label={'Main Menu'} secondary={true} onClick={onClickBack} />
          <Button label={'Close'} autoFocus secondary={true} onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </>
  );

  const footer = <Button label={'Back'} secondary={true} onClick={onClickBack} />;
  return <MenuContainer content={content} footer={footer} />;
};
